import { render, staticRenderFns } from "./PaySuccessBack.vue?vue&type=template&id=65bb5574&scoped=true"
import script from "./PaySuccessBack.vue?vue&type=script&lang=js"
export * from "./PaySuccessBack.vue?vue&type=script&lang=js"
import style0 from "./PaySuccessBack.vue?vue&type=style&index=0&id=65bb5574&prod&lang=less&scoped=true"
import style1 from "./PaySuccessBack.vue?vue&type=style&index=1&id=65bb5574&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bb5574",
  null
  
)

export default component.exports